var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3808 6.29721C14.6508 6.55716 14.6589 6.98673 14.3989 7.25668L8.51799 13.3638C8.39008 13.4967 8.21361 13.5717 8.0292 13.5717C7.8448 13.5717 7.66833 13.4967 7.54042 13.3638L4.59994 10.3103C4.33999 10.0403 4.34809 9.61073 4.61804 9.35078C4.88799 9.09082 5.31756 9.09893 5.57752 9.36888L8.0292 11.9149L13.4214 6.31531C13.6813 6.04536 14.1109 6.03725 14.3808 6.29721Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 17.9821C14.1846 17.9821 17.9821 14.1846 17.9821 9.5C17.9821 4.81544 14.1846 1.01786 9.5 1.01786C4.81544 1.01786 1.01786 4.81544 1.01786 9.5C1.01786 14.1846 4.81544 17.9821 9.5 17.9821ZM9.5 19C14.7467 19 19 14.7467 19 9.5C19 4.25329 14.7467 0 9.5 0C4.25329 0 0 4.25329 0 9.5C0 14.7467 4.25329 19 9.5 19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyStatus);
export default __webpack_public_path__ + "static/media/verifyStatus.709eca71094db23025c8a6953fb7cc7b.svg";
export { ForwardRef as ReactComponent };